module.exports = __webpack_public_path__ + "static/media/logo.ee764236.png";